module.exports = __webpack_public_path__ + "static/media/ai-wechat-qrcode-v3.f6b9ff1f.png";